// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1b9sS","label":"Labeled_label__3fkct","divider":"Labeled_divider__1ELSg"};